import React, { Component } from 'react'
import { Dialog, Card, CardContent, TextField, Button } from '@material-ui/core'
import { connect } from 'react-redux'
import { updateUserPut } from '../../actions/users'

class EmailModal extends Component {
  state = {
    email: ''
  }
  componentDidUpdate() {
    const p = this.props,
      auth = p.authentication
    if (!(auth && auth.authenticatedUser && auth.authenticatedUser.role && auth.authenticatedUser.role === 'buyer')) {
      if (
        auth &&
        auth.authenticatedUser &&
        !auth.authenticatedUser.email &&
        !this.props.open
      ) {
        this.props.dispatch({ type: 'EMAIL_MODAL', payload: true })
      } else if (
        this.props.open &&
        auth &&
        auth.authenticatedUser &&
        auth.authenticatedUser.email
      ) {
        this.props.dispatch({ type: 'EMAIL_MODAL', payload: false })
      }
    }
  }
  render() {
    return (
      <Dialog open={this.props.open && this.props.auth && this.props.auth.authenticatedUser}>
        <Card>
          <CardContent>
            <h3 style={{ margin: '0' }}>Please complete your profile</h3>
          </CardContent>
          <CardContent>
            <span>We need your email to complete your account</span>
          </CardContent>
          <form
            onSubmit={e => {
              e.preventDefault()
              const obj = {}
              const user = this.props.authentication.authenticatedUser
              obj.phone = user.phone
              obj.email = this.state.email
              this.props.dispatch({ type: 'EMAIL_MODAL', payload: false })
              this.props.dispatch(updateUserPut(user.id, obj))
            }}
          >
            <CardContent>
              <TextField
                label="Email"
                onChange={e => this.setState({ email: e.target.value })}
                value={this.state.email}
                type="email"
                required
                fullWidth
              />
            </CardContent>
            <CardContent>
              <div style={{ display: 'flex' }}>
                <div style={{ flexGrow: 1 }} />
                <Button color="primary" variant="contained" type="submit">
                  Submit
                </Button>
              </div>
            </CardContent>
          </form>
        </Card>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    open: state.emailModal,
    authentication: state.authentication
  }
}

const connector = connect(mapStateToProps)

export default connector(EmailModal)
